// comes from FreightTransportGoodsType in queries-processed
export enum EFreightTransportGoodsType {
  NORMAL = 'NORMAL',
  ANIMAL = 'ANIMAL',
  ADR = 'ADR',
  WASTE = 'WASTE',
  ADR_WASTE = 'ADR_WASTE',
}

export enum EFreightLoadingType {
  REAR = 'REAR',
  SIDE = 'SIDE',
  TOP = 'TOP',
}
